import { render, staticRenderFns } from "./FailModal.vue?vue&type=template&id=a3db5076&scoped=true&"
import script from "./FailModal.vue?vue&type=script&lang=ts&"
export * from "./FailModal.vue?vue&type=script&lang=ts&"
import style0 from "./FailModal.vue?vue&type=style&index=0&id=a3db5076&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3db5076",
  null
  
)

export default component.exports